module.exports = '<svg width="40" height="32" viewBox="0 0 40 32"><path d="M39.436 14.64L25.992.588a1.862 1.862 0 0 0-2.716 0l-2.712 2.836a2.07 2.07 0 0 0 0 2.84l9.372 9.796-9.252 9.672a2.07 2.07 0 0 0 0 2.84l2.716 2.84a1.862 1.862 0 0 0 2.716 0L39.44 17.488a2.084 2.084 0 0 0-.004-2.848zM5.992.588a1.862 1.862 0 0 0-2.716 0L.564 3.424a2.07 2.07 0 0 0 0 2.84l9.372 9.796-9.252 9.672a2.07 2.07 0 0 0 0 2.84l2.716 2.84a1.862 1.862 0 0 0 2.716 0L19.44 17.488a2.075 2.075 0 0 0 0-2.844L5.992.588z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/fast-forward-3.js
// module id = 1141
// module chunks = 14